import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryCreator } from "redux/baseQuery";

import env from "env";

import { DetermineApproversRequest, DetermineApproversResponse } from "./types";

const { approvalRuleService } = env.api.baseUrl;
const baseQuery = fetchBaseQuery({
  baseUrl: approvalRuleService,
  prepareHeaders: (headers, { getState }: any) => {
    const token = getState().auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const approvalRuleApi = createApi({
  reducerPath: "approvalRuleApi",
  baseQuery: baseQueryCreator(baseQuery),
  endpoints: (builder) => ({
    determineApprovers: builder.mutation<
      DetermineApproversResponse,
      DetermineApproversRequest
    >({
      query: ({ orgToken, ...form }) => {
        return {
          url: `/approvers`,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "org-token": orgToken,
          },
          body: form,
        };
      },
    }),
  }),
});

export const { useDetermineApproversMutation } = approvalRuleApi;
